export default "__VITE_ASSET__BeWwIqdj__"